import React from "react";
import { getMetricLabel } from "@linkfluence/i18n";
import { Metric } from "@linkfluence/models/metric";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

export default function SharedCardsSubtitleMetric({
  metric,
}: {
  metric: Metric;
}) {
  const locale = useCurrentUserLocale();
  return <>{getMetricLabel(locale, metric)}</>;
}
